import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

import { REHIRE_ELIGIBLE_TYPES, RehireEligibleText } from './utils/rehire-eligible-types';

type InputProps = {
  employee?: Employee;
  rehireEligible: string | null;
  setRehireEligible: (newRehireEligible: string) => void;
};

export const RehireEligibleFormBody = (props: InputProps) => {
  const { employee, rehireEligible, setRehireEligible } = props;

  const rehireEligibleOptions = [
    {
      value: REHIRE_ELIGIBLE_TYPES.YES,
      label: RehireEligibleText[REHIRE_ELIGIBLE_TYPES.YES],
    },
    {
      value: REHIRE_ELIGIBLE_TYPES.NO,
      label: RehireEligibleText[REHIRE_ELIGIBLE_TYPES.NO],
    },
    {
      value: REHIRE_ELIGIBLE_TYPES.DONT_KNOW,
      label: RehireEligibleText[REHIRE_ELIGIBLE_TYPES.DONT_KNOW],
    },
  ];

  const handleChangeRehireEligible = (selectedRehireEligible: RehireEligibleOptions) => () => {
    setRehireEligible(selectedRehireEligible);
  };

  const questionLabel = employee
    ? `Is ${employee.Contact.Person.firstName} eligible for rehire?`
    : 'Eligible for rehire?';

  return (
    <div className="u-margin-top-lg">
      <div>{questionLabel}</div>
      <div className="u-display-flex">
        {rehireEligibleOptions.map((option) => (
          <div key={`new-hire-eligible-${option.value.toLowerCase()}`}>
            <FormControlLabel
              control={
                <Radio
                  checked={rehireEligible === option.value}
                  onChange={handleChangeRehireEligible(option.value)}
                  value={option}
                />
              }
              label={option.label}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
